import request from '@/service/api'
import ConfigType from '@/service/api/type'
enum dicApi {
    DICDATA = '/sysDictData/listbycode'
}
export const getSysDicListData = (data: any): ConfigType<any> => { //字典查询
    return request({
        url: `${dicApi.DICDATA}`,
        method: 'get',
        params: data
    })
}
export const localattribute = (data: any): ConfigType<any> => { //字典查询
    return request({
        url: `${dicApi.DICDATA}`,
        method: 'get',
        params: data
    })
}